// @ts-nocheck
(() => {
  /** @param {HTMLElement} root */
  const collect = (root) => {
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    const panels = [...root.querySelectorAll('.fwrd-product-tabs__panels [role="tabpanel"]')];
    return { tabs, panels };
  };

  /**
   * @param {HTMLElement} root
   * @param {number} index
   */
  /** @param {HTMLElement} panel */
  const initFaqInPanel = (panel) => {
    panel.querySelectorAll('.faq-section__item:not([data-faq-ready])').forEach((item, index) => {
      item.setAttribute('data-faq-ready', 'true');
      const questionWrapper = item.querySelector('.faq-section__question-wrapper');
      const arrowIcon = item.querySelector('.faq-section__arrow-icon');
      if (!questionWrapper || !arrowIcon) return;

      arrowIcon.style.transition = 'transform 0.3s ease';

      if (index === 0) {
        item.classList.add('open');
        arrowIcon.style.transform = 'rotate(180deg)';
      }

      questionWrapper.addEventListener('click', () => {
        const isOpen = item.classList.contains('open');
        if (isOpen) {
          item.classList.remove('open');
          arrowIcon.style.transform = 'rotate(0deg)';
        } else {
          item.classList.add('open');
          arrowIcon.style.transform = 'rotate(180deg)';
        }
      });
    });
  };

  const select = (root, index) => {
    const { tabs, panels } = collect(root);
    if (index < 0 || index >= tabs.length) return;

    tabs.forEach((tab, i) => {
      const active = i === index;
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
    });

    panels.forEach((panel, p) => {
      if (p === index) {
        panel.removeAttribute('hidden');
        initFaqInPanel(panel);
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  };

  /** @param {KeyboardEvent} e */
  const onTablistKeydown = (e) => {
    if (!(e.target instanceof Element)) return;
    const tablist = e.target.closest('[role="tablist"]');
    if (!tablist) return;
    const root = tablist.closest('[data-fwrd-product-tabs]');
    if (!(root instanceof HTMLElement)) return;

    const { key } = e;
    if (!['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp', 'Home', 'End'].includes(key)) return;

    const tabs = [...root.querySelectorAll('[role="tab"]')];
    const current = tabs.indexOf(document.activeElement);
    if (current === -1) return;

    const len = tabs.length;
    let next = current;

    if (key === 'ArrowRight' || key === 'ArrowDown') {
      next = (current + 1) % len;
      e.preventDefault();
    } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
      next = (current - 1 + len) % len;
      e.preventDefault();
    } else if (key === 'Home') {
      next = 0;
      e.preventDefault();
    } else if (key === 'End') {
      next = len - 1;
      e.preventDefault();
    }

    if (next !== current) {
      select(root, next);
      tabs[next].focus();
    }
  };

  /** @param {HTMLElement} root */
  const init = (root) => {
    if (root.getAttribute('data-fwrd-product-tabs-initialized') === 'true') return;
    root.setAttribute('data-fwrd-product-tabs-initialized', 'true');

    const tabListEl = root.querySelector('[role="tablist"]');
    if (!(tabListEl instanceof HTMLElement)) return;

    tabListEl.addEventListener('click', (e) => {
      if (!(e.target instanceof Element)) return;
      const tab = e.target.closest('[role="tab"]');
      if (!tab || !tabListEl.contains(tab)) return;
      const section = tab.closest('[data-fwrd-product-tabs]');
      if (!(section instanceof HTMLElement)) return;
      const tabs = [...section.querySelectorAll('[role="tab"]')];
      const index = tabs.indexOf(tab);
      if (index >= 0) select(section, index);
    });

    tabListEl.addEventListener('keydown', onTablistKeydown);

    const { tabs } = collect(root);
    let initial = 0;
    for (let k = 0; k < tabs.length; k++) {
      if (tabs[k].getAttribute('aria-selected') === 'true') {
        initial = k;
        break;
      }
    }
    select(root, initial);
  };

  document.querySelectorAll('[data-fwrd-product-tabs]').forEach((el) => {
    if (el instanceof HTMLElement) init(el);
  });

  window.FwrdProductTabs = {
    /** @param {HTMLElement} root @param {number} index */
    select: (root, index) => {
      if (!(root instanceof HTMLElement)) return;
      select(root, index);
    },
  };

  document.addEventListener('shopify:section:load', (event) => {
    if (!(event.target instanceof HTMLElement)) return;
    event.target.querySelectorAll('[data-fwrd-product-tabs]').forEach((el) => {
      el.removeAttribute('data-fwrd-product-tabs-initialized');
      if (el instanceof HTMLElement) init(el);
    });
  });
})();
